import React from 'react';
import { Button } from '../ui/button';
import { FUNDING_SEQUENCE_PHASES } from '../../utils/funding/constants';

const FundingSequenceReorderControls = ({ item, onMovePhase, disabled }) => {
  const currentIndex = FUNDING_SEQUENCE_PHASES.indexOf(item.phase);
  const prevPhase = currentIndex > 0 ? FUNDING_SEQUENCE_PHASES[currentIndex - 1] : null;
  const nextPhase = currentIndex < FUNDING_SEQUENCE_PHASES.length - 1 ? FUNDING_SEQUENCE_PHASES[currentIndex + 1] : null;

  return (
    <>
      {prevPhase ? (
        <Button size="sm" variant="outline" className="rounded-xl" disabled={disabled} onClick={() => onMovePhase(item, prevPhase)}>
          ← {prevPhase}
        </Button>
      ) : null}
      {nextPhase ? (
        <Button size="sm" variant="outline" className="rounded-xl" disabled={disabled} onClick={() => onMovePhase(item, nextPhase)}>
          {nextPhase} →
        </Button>
      ) : null}
    </>
  );
};

export default FundingSequenceReorderControls;
